import ErrorType from '@models/error';
import axios, { AxiosResponse } from 'axios';
import FormData from 'form-data';
import config from '../../config';
import {
  GetCommentsResponse,
  GetEpisodeResponse,
  GetEpisodesResponse,
  GetPodcastResponse,
  GetTopicResponse,
  GetTopicsResponse,
  LoginResponse,
} from '@models/responses';
import { PreviewOrderResult } from '@models/Order';

export default class API {
  static callAPI(
    path: string,
    method: 'GET' | 'POST' = 'GET',
    body?: string | FormData,
    headers?: any
  ) {
    switch (method) {
      case 'POST':
        return axios.post(config.API_URL + path, body, { headers });
      default:
        return axios.get(config.API_URL + path, { headers });
    }
  }

  static getEpisode(id: string): Promise<AxiosResponse<GetEpisodeResponse>> {
    return this.callAPI('/episode/get_detail?id=' + id);
  }

  static getHomePageCourses() {
    return this.callAPI('/topic/home_page_list');
  }

  static getTopic(id: string): Promise<AxiosResponse<GetTopicResponse>> {
    return this.callAPI('/topic/get_topic?id=' + id + '&show_episode=true');
  }

  static getPodcast(id: string): Promise<AxiosResponse<GetPodcastResponse>> {
    return this.callAPI('/podcast/get_podcast?id=' + id, 'GET', '',
      { 'auth-token': config.API_AUTH_TOKEN, });
  }

  static getTopics(
    podcastId: string
  ): Promise<AxiosResponse<GetTopicsResponse>> {
    return this.callAPI(
      '/topic/get_topic_list?podcast_id=' + podcastId,
      'GET',
      '',
      { 'auth-token': config.API_AUTH_TOKEN }
    );
  }

  static updateListenHistory(episodeId: string, position: number,
    duration: number) {
    const req = new FormData();
    req.append('episode_id', episodeId);
    req.append('position', position.toString());
    req.append('duration', duration.toString());
    return this.callAPI('/episode/update_history', 'POST', req,
      { 'auth-token': config.API_AUTH_TOKEN });
  }

  static getEpisodes(
    podcastId: string
  ): Promise<AxiosResponse<GetEpisodesResponse>> {
    return this.callAPI(
      '/episode/all?offset=0&&podcast_id=' + podcastId,
      'GET',
      '',
      { 'auth-token': config.API_AUTH_TOKEN }
    );
  }

  static previewOrder(form: any): Promise<AxiosResponse<PreviewOrderResult>> {
    const req = new FormData();
    req.append('topic_id', form.topicId);
    req.append('sku_id', form.skuId);
    req.append('purchase_type', form.purchaseType);
    req.append('coupon_code', form.couponCode);
    if (form.periodDiscountDay) req.append('period_discount_day',
      form.periodDiscountDay.toString());
    return this.callAPI('/checkout/preview_order', 'POST', req,
      { 'auth-token': config.API_AUTH_TOKEN });
  }

  static async userLogin(params: any) {
    const formData = new FormData();
    for (const key in params)
      if (params.hasOwnProperty(key)) formData.append(key, params[key]);

    const res = await this.callAPI(
      '/login',
      'POST',
      formData,
      formData.getHeaders()
    );

    const parsedResponse = ((await res.data) as any) as LoginResponse;

    if (!parsedResponse.result) throw parsedResponse.message;
    return parsedResponse;
  }

  static async getComments(episodeId: string) {
    const res = await this.callAPI(
      `/comment/get_comments?episode_id=${episodeId}`
    );
    const parsedRes: GetCommentsResponse = res.data;
    if (!parsedRes.result) throw ErrorType.RESULT_FALSE;
    return parsedRes.datas;
  }
}
